<template>
  <div>
    <!-- Header -->
    <v-parallax
      class="banner-container mt-8"
      height="250"
      :src="require('@/assets/faq-bcg-image.svg')"
    >
      <div class="heading-h1 banner-content text-center black--text mb-6">
        Founder's Story
        <br />
        <v-img
          class="mark"
          style="margin-left: 41%; height: 100%; width: 18%"
          :src="require('@/assets/mark.jpg')"
        ></v-img>
      </div>
    </v-parallax>

    <!-- Content -->

    <div class="mt-2 overview-container">
      <p>
        I created Easi Rewards with a simple idea in mind. Create a fun platform
        for parents to use with their kids that helps motivate them to engage in
        positive behaviours EVERY DAY.
      </p>
      <p>
        As a parent of 3 children I was as stuck in the motivational mud getting
        my kids to do things they needed to do as much as any other parent I
        knew. Stars and smarties when they were younger worked but not as they
        got older. Weekly allowances grow to entitlement and bribes work for
        very short-term behaviours that never stick around. I needed a better
        way to get the chore wars won. But what?
      </p>
      <p>
        I was already an avid collector of points. Getting points for buying the
        things we need to buy anyway just seems like a no brainer, right? The
        psychology of using points to drive behaviours is well understood. I was
        even using it with my employees at work to great results. The perceived
        value of getting something for “free” really works to motivate people
        and usually in a cheaper way than using cash.
      </p>
      <p>
        I became fixated on this idea of creating a real points program that
        parents can use with their kids in order to help motivate and reward
        them. I was certain that kids would love collecting points for things
        that their parents are fighting with them over every day. “Do your
        chores, get some exercise, read a book, take up an instrument…just put
        that $#@ game down!”
      </p>
      <p>
        I created Easi Rewards so parents could give points to their kids for
        <b>any</b> quest they wanted to set for their kids. My 10-year-old now
        <b>begs</b> me to add quests for her to complete. I don’t give her basic
        quests…“No honey, I’m not giving you quests to brush your teeth and make
        your bed!”….but now she’s putting down the iPad and reading every day,
        doing extra homework helping to instil good school habits and she’s
        helping around the house all while having fun and collecting points
        doing them. She’s learning to save for the things she wants and feels a
        lot more independent as she orders her own rewards through the product
        catalog.
      </p>
      <p>
        Chore wars don’t feel like wars anymore. That’s precisely why I launched
        Easi Rewards in the first place!
      </p>
      <p>Mark Morais - Founder & Chief Motivator</p>
    </div>
  </div>
</template>
<script>
import { ABOUT_META } from '../consts/metaTags';

export default {
  name: 'AboutUsPage',
  metaInfo() {
    return ABOUT_META;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AboutUsPage.vue